export class FormField {
  constructor(
    public add?: boolean,
    public atLeastOneRequired?: [[string]],
    public align?: string,
    public blankOptionVisible?: boolean,
    public csv?: boolean,
    public draggable?: boolean,
    public defaultValue?: any,
    public disclaimers?: Disclaimer[],
    public dropdownWidth?: number,
    public id?: string,
    public fields?: any,
    public files?: boolean,
    public folders?: boolean,
    public format?: string,
    public frames?: boolean,
    public hint?: string,
    public hints?: string[],
    public highlightColor?: string,
    public highlightLinkedId?: string,
    public highlightPattern?: string,
    public highlightValues?: any[],
    public integer?: boolean,
    public label?: string,
    public links?: Link[],
    public linkedPattern?: PatternSegment[],
    public locked?: boolean,
    public max?: number,
    public min?: number,
    public path?: string,
    public pattern?: string,
    public placeholder?: string,
    public positive?: boolean,
    public prefix?: string,
    public suffix?: string,
    public suffixes?: string[],
    public required?: boolean,
    public rowId?: string,
    public sortBy?: string[],
    public type?: string,
    public values?: FieldValue[],
    public columns?: number, // 1 to 3 columns
    public validValues?: Array<number>
  ) { }
}

interface FieldValue {
  displayed?: string,
  stored?: string
}

export interface Link {
  addOnly?: boolean,
  fields?: string[],
  id?: string,
  pattern?: string,
  presence?: string,
  match?: any,
  row?: boolean
}

export interface Disclaimer {
  value: string,
  statements: string[],
  state?: string
}

export interface PatternSegment {
  field?: string,
  optional?: boolean,
  prefix?: string,
  value?: string
}



// WEBPACK FOOTER //
// ./src/app/forms/form-field.model.ts